import React from "react";
import styles from "./StatusPanel.module.css";


import { FaInfoCircle, FaUserFriends, FaClock } from "react-icons/fa";

export default function StatusPanel({ userData }) {
  const assetsAdded =
  Object.values(userData?.assets || {}).some(
    (sub) => Array.isArray(sub) && sub.length > 0
  );

const liabilitiesAdded =
  Object.values(userData?.liabilities || {}).some(
    (sub) => Array.isArray(sub) && sub.length > 0
  );

const maintenanceAdded =
  Object.values(userData?.maintenance || {}).some(
    (sub) => Array.isArray(sub) && sub.length > 0
  );

// Your existing infoDocs structure
const infoDocsAdded =
  (userData?.infoDocs?.Documents?.length || 0) > 0 ||
  (userData?.infoDocs?.Notes?.length || 0) > 0;

// FINAL unified check
const infoAdded =
  assetsAdded || liabilitiesAdded || maintenanceAdded || infoDocsAdded;

  const contactsAdded =
  Array.isArray(userData?.trustedContacts?.trustedContacts) &&
  userData.trustedContacts.trustedContacts.length > 0;


  const inactivityAdded =
  userData?.inactivitySettings?.inactivitySettings?.inactivityPeriodInMonths > 0 ||
  userData?.inactivitySettings?.inactivitySettings?.reminderCountBeforeSend > 0;


	const statusItems = [
	  { 
		label: "Information Addition", 
		value: infoAdded, 
		icon: <FaInfoCircle />,
		description: "This section tracks if you’ve added any assets, liabilities, documents, or maintenance details."
	  },
	  { 
		label: "Trusted Contacts", 
		value: contactsAdded, 
		icon: <FaUserFriends />,
		description: "These are the people you trust most to receive your information if your account becomes inactive and you don’t respond to the reminders we send."
	  },
	  { 
		label: "Inactivity Settings", 
		value: inactivityAdded, 
		icon: <FaClock />,
		description: "1. Set how long your account can stay inactive.\n2. After that period, we’ll send the reminders you selected\n3. If there’s no response, we’ll notify your trusted contacts."
	  }
	];

  const total = statusItems.length;
  const completed = statusItems.filter((i) => i.value).length;
  const percent = Math.round((completed / total) * 100);

  return (
    <div className={styles.statusColumn}>
      <h2 className={styles.statusTitle}>Status Overview</h2>

      {/* Progress Bar */}
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${percent}%` }}
        ></div>
      </div>
      <p className={styles.progressText}>{percent}% Complete</p>

      {/* Status Items */}
      {statusItems.map((item, index) => (
		<div
		  key={index}
		  className={`${styles.statusItem} ${
			item.value ? styles.statusItemCompleted : styles.statusItemPending
		  }`}
		>
		  <div className={styles.statusTopRow}>
			<div className={styles.statusLeft}>
			  <span className={styles.statusIcon}>{item.icon}</span>
			  <span>{item.label}</span>
			</div>

			<span className={item.value ? styles.greenTick : styles.redTick}>
			  {item.value ? "✔" : "✖"}
			</span>
		  </div>

		  <p className={styles.statusDefinition}>{item.description}</p>
		</div>


      ))}
    </div>
  );
}
